export default "__VITE_ASSET__DEt109$J__"